module.exports = __webpack_public_path__ + "static/media/logo.2382765d.svg";